<template>
  <el-card style="min-height: 480px">
    <span slot="header">个人资料</span>
    <el-form size="small">
      <el-form-item label="姓名">
        <el-input readonly type="text" v-model="form.name"></el-input>
      </el-form-item>
      <el-form-item label="手机号码" prop="phone">
        <el-input
          readonly
          type="text"
          oninput="value=value.replace(/\D/g,'')"
          placeholder="请输入数字"
          v-model="form.phone"
          maxlength="11"
        >
        </el-input>
      </el-form-item>
      <el-form-item prop="memo" label="备注">
        <el-input
          type="textarea"
          v-model="form.memo"
          maxlength="200"
          :autosize="{ minRows: 3 }"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submit"> 保存资料修改 </el-button>
      </el-form-item>
    </el-form>
  </el-card>
</template>
<script>
import { personUpdateMeno, userInfo } from '@/api/person.js'
export default {
  name: 'ProfileMemo',
  props: {
    /**
     * 用户id
     */
    personId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      form: {
        id: '',
        name: '',
        phone: '',
        memo: '',
      },
    }
  },
  mounted() {
    userInfo(this.personId).then((resp) => {
      Object.assign(this.form, resp.data)
    })
  },
  methods: {
    submit() {
      personUpdateMeno(this.personId, { memo: this.form.memo }).then((resp) => {
        this.$message.success('修改成功')
      })
    },
  },
}
</script>


// WEBPACK FOOTER //
// src/components/_profile/Memo.vue